export default "<main>\r\n    <router-outlet></router-outlet>\r\n    </main>"